// monstrs の問い合わせウィジェット（IIFE）を 1 回だけ読み込み、window.MonstrsInquiry を返す。
// document / window は差し替えられるようにして、テストで実ブラウザやネットワークを使わない。

// document ごと、URL ごとの読み込み Promise（読み込み中・読み込み済みの重複防止）
const cacheByDocument = new WeakMap()

const cacheOf = (doc) => {
  if (!cacheByDocument.has(doc)) cacheByDocument.set(doc, new Map())
  return cacheByDocument.get(doc)
}

export const loadInquiryWidget = (url, { doc = document, win = window } = {}) => {
  const cache = cacheOf(doc)
  if (cache.has(url)) return cache.get(url)

  const promise = new Promise((resolve, reject) => {
    const script = doc.createElement('script')
    const fail = (error) => {
      cache.delete(url)
      if (script.parentNode) script.parentNode.removeChild(script)
      reject(error)
    }
    script.src = url
    script.async = true
    script.addEventListener('load', () => {
      const widget = win.MonstrsInquiry
      if (widget && typeof widget.mount === 'function') {
        resolve(widget)
      } else {
        fail(new Error('inquiry-widget-mount-missing'))
      }
    })
    script.addEventListener('error', () => fail(new Error('inquiry-widget-load-failed')))
    doc.head.appendChild(script)
  })
  cache.set(url, promise)
  return promise
}
